<template>
  <b-modal
    id="review-message"
    title="Review Message and OTP Code Verification"
    centered
    hide-footer
    size="lg"
  >
    <!-- hide-footer -->

    <b-form-group label="Message">
      <b-form-textarea
        v-model="message"
        input-id="message"
        id="message"
        placeholder="Message"
        rows="6"
        readonly
      />
      <small
        >{{ messageCharacters }} characters.
        {{ noOfMessages }} message(s)</small
      >
    </b-form-group>

    <b-form-group>
      <div class="d-flex justify-content-between align-items-center">
        <label for="otpCode">OTP Code</label>
        <a @click="resendOtpCode">Resend OTP Code</a>
      </div>
      <b-form-input
        v-model="otpCode"
        input-id="otpCode"
        id="otpCode"
      />
      <small class="text-danger" v-if="formInvalid">The OTP code field is required</small>
    </b-form-group>


    <div class="text-right">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="secondary"
        @click="$bvModal.hide('review-message')"
        class="mr-2"
      >
        Cancel
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="sendMessage"
      >
        <span class="align-middle">Send</span>
        <feather-icon icon="SendIcon" class="ml-50" />
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BFormGroup, BFormInput, BFormTextarea, BSpinner, BButton } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  directives: {
    Ripple,
  },
  components: {
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BSpinner,
    BButton,
  },
  props: ["message", "messageCharacters", "noOfMessages"],
  emits: ["send-message"],
  data(){
    return{
      otpCode: null,
      formInvalid:false,
    }
  },
  methods: {
    sendMessage() {
      if (this.otpCode){
        this.$emit("send-message", this.otpCode);
        this.$bvModal.hide('review-message');
        this.otpCode = null;
      } else {
        this.formInvalid = true;
      }
    },
    resendOtpCode(){
      this.$http
        .get("/sms/opt/send")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: response.data.message,
              icon: "CheckIcon",
              variant: "success",
              text: "kindly verify it to send SMS(s) from MyBulkSMS platform.",
            },
          });
        })
        .catch((error) => {
          for (let err of error.response.data.error) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: err,
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }
        });
    }
  },
};
</script>